/* =========================================================
   PCA — DESIGN F 随時更新レイヤ（プログレッシブ・エンハンスメント）
   app.js がベイク済みスナップショットを描画した後で、本店の公開データを
   ブラウザから直接取得し、該当セクションを「今の最新」に差し替える。
     - NEW ARRIVAL … casebypca.com/products.json（新着＝published_at降順の在庫あり8件）
     - みんなのレビュー … Judge.me reviews_for_widget（人気商品IDの実レビュー最新5件）
     - よみもの … casebypca.com/blogs/ニュース.atom（ブログ最新記事1件）
   取得失敗（オフライン等）時はスナップショットのまま（no-op）。
   ※本店(casebypca.com)では同一オリジン、プレビュー(pages.dev)ではCORS許可済みで動作。
   ========================================================= */
(function () {
  "use strict";

  var SHOP = "https://casebypca.com";
  var C = typeof CONTENT_F !== "undefined" ? CONTENT_F : {};

  /* ---- NEW ARRIVAL リプレイス品判定 ----------------------------------------
     クライアントの採番規則: 新規登録は当年の管理番号（例: 26xxxx）を使用。
     過去商品を再作成した「リプレイス品」は旧番号（23/24/25xxxx）のまま
     再登録し公開日だけが最近になる → published_at順だと上位を占めてしまう。
     handleから6桁管理番号を抽出し、先頭2桁が (今年-1)〜今年 なら新規、
     それ未満なら除外。番号が抽出できない場合は created_at 60日以内で救済。
     ------------------------------------------------------------------------- */
  var NOW = new Date();
  var CUR_YY = NOW.getFullYear() % 100;   // 例: 2026 → 26
  var MIN_YY = CUR_YY - 1;                // 前年まで許容
  function extractMgmtYY(handle) {
    // handle例: "260096", "230910", "ホログラム-…-231023"
    if (!handle) return null;
    var m = String(handle).match(/(?:^|[^0-9])(\d{6})(?:$|[^0-9])/);
    if (!m) return null;
    return parseInt(m[1].slice(0, 2), 10);
  }
  function isNewArrival(p) {
    var yy = extractMgmtYY(p.handle);
    if (yy != null) return yy >= MIN_YY;   // 26xxxx/25xxxx=新規、23/24=除外
    // フォールバック: 番号が取れない handle は created_at 60日以内なら新規扱い
    var t = new Date(p.created_at || p.published_at || 0).getTime();
    return t && (NOW.getTime() - t) <= 60 * 24 * 3600 * 1000;
  }

  function cleanTitle(t) {
    return String(t == null ? "" : t)
      .replace(/[#＃]\s*\d+\s*$/u, "")
      .replace(/\s+$/u, "")
      .trim();
  }
  function yen(v) {
    var n = Number(String(v).replace(/[^\d.]/g, ""));
    return isFinite(n) ? "¥" + n.toLocaleString("ja-JP") : "";
  }
  function starsHTML(n) {
    n = Math.max(0, Math.min(5, n || 0));
    return (
      '<span class="stars" aria-label="星' + n + 'つ">' +
      "★".repeat(n) + "☆".repeat(5 - n) + "</span>"
    );
  }
  function getJSON(u) {
    return fetch(u, { mode: "cors", credentials: "omit" }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  }
  function elem(tag, cls) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    return e;
  }

  /* 画像配信の最適化（2026-08-13 TOP高速化）。f-app.js の cdnUrl/imgAttrs と同じ考え方。
     Shopify CDNの ?width= で表示幅に縮小して配信し、1x/2x を srcset で出し分ける。 */
  function cdnUrl(url, w) {
    if (!url || typeof url !== "string") return url;
    if (!/(cdn\.shopify\.com|\/cdn\/shop\/)/.test(url)) return url;
    var parts = url.split("?");
    var q = (parts[1] || "").split("&").filter(function (p) {
      return p && !/^(width|height|crop)=/.test(p);
    });
    q.push("width=" + w);
    return parts[0] + "?" + q.join("&");
  }

  // img要素に表示幅 w ぶんの src/srcset を入れる
  function setImg(im, url, w) {
    var x1 = cdnUrl(url, w);
    var x2 = cdnUrl(url, w * 2);
    im.src = x1;
    if (x1 !== x2) im.srcset = x1 + " 1x, " + x2 + " 2x";
    im.decoding = "async";
  }

  /* ---- 共有キャッシュ（NEW ARRIVAL / RANKING で重複フェッチ回避） */
  var _newestPromise = null;
  var _rankingPromise = null;
  function fetchNewestProducts() {
    if (!_newestPromise) {
      _newestPromise = getJSON(SHOP + "/products.json?limit=60")
        .then(function (d) { return d.products || []; })
        .catch(function () { return []; });
    }
    return _newestPromise;
  }
  function fetchRankingProducts() {
    if (!_rankingPromise) {
      _rankingPromise = getJSON(SHOP + "/collections/ranking/products.json?limit=10")
        .then(function (d) { return d.products || []; })
        .catch(function () { return []; });
    }
    return _rankingPromise;
  }

  /* ---- Judge.me 実レビュー件数（商品ID→総件数）--------------------------------
     公開ウィジェットAPIのレスポンスは {html, total_count, page}。
     総件数は **トップレベル d.total_count**（pagination配下ではない）。
     取れなければ null（表示据置）。product_idごとにPromiseキャッシュ。
     ※以前は d.pagination.total_count を見ていたが空オブジェクトのため常にhtml
       フォールバック→per_page=1で最大1にキャップされ「件数が増えない」不具合だった。 */
  var _reviewCountCache = {};
  function fetchReviewCount(id) {
    if (id == null) return Promise.resolve(null);
    if (_reviewCountCache[id]) return _reviewCountCache[id];
    var u = "https://judge.me/reviews/reviews_for_widget?url=casebypca.com" +
      "&shop_domain=casebypca.com&platform=shopify&product_id=" + id +
      "&per_page=1&page=1";
    _reviewCountCache[id] = getJSON(u).then(function (d) {
      if (typeof d.total_count === "number" && d.total_count >= 0) {
        return d.total_count;
      }
      var n = parseInt(d.total_count, 10);        // 文字列で来る場合の保険
      if (isFinite(n) && n >= 0) return n;
      var pag = d.pagination || {};
      if (typeof pag.total === "number") return pag.total;
      var html = d.html || "";
      var m = html.match(/data-total-review[^=]*=['"](\d+)['"]/);
      if (m) return parseInt(m[1], 10);
      return (html.match(/data-review-id=['"]/g) || []).length;
    }).catch(function () { return null; });
    return _reviewCountCache[id];
  }

  /* ---- NEW ARRIVAL：本店の最新入荷を随時反映（リプレイス品を除外） ---- */
  function refreshNewArrivals() {
    fetchNewestProducts().then(function (all) {
      var ps = all.filter(function (p) {
        if (!(p.variants || []).some(function (v) { return v.available; })) return false;
        return isNewArrival(p);   // ★ リプレイス品(旧管理番号)は除外
      });
      ps.sort(function (a, b) {
        return (
          new Date(b.published_at || b.created_at || 0) -
          new Date(a.published_at || a.created_at || 0)
        );
      });
      ps = ps.slice(0, 8);
      if (!ps.length) return;
      var grid = document.querySelector(".sec-new .product-grid");
      if (!grid) return;
      var frag = document.createDocumentFragment();
      ps.forEach(function (p) {
        var img = (p.images && p.images[0] && p.images[0].src) || "";
        var price = (p.variants && p.variants[0] && p.variants[0].price) || "";
        var a = elem("a", "product-card");
        a.href = SHOP + "/products/" + p.handle;
        a.setAttribute("aria-label", cleanTitle(p.title));
        var media = elem("div", "product-media");
        var tag = elem("span", "product-tag");
        tag.textContent = "NEW";
        media.appendChild(tag);
        var im = elem("img", "product-img");
        im.loading = "lazy";
        setImg(im, img, 280);
        im.alt = cleanTitle(p.title);
        media.appendChild(im);
        a.appendChild(media);
        var body = elem("div", "product-body");
        var tt = elem("p", "product-title");
        tt.textContent = cleanTitle(p.title);
        body.appendChild(tt);
        var pr = elem("p", "price");
        pr.textContent = yen(price);
        body.appendChild(pr);
        a.appendChild(body);
        frag.appendChild(a);
      });
      grid.innerHTML = "";
      grid.appendChild(frag);
    }).catch(function () { /* スナップショット維持 */ });
  }

  /* ---- 人気RANKING：/collections/ranking から TOP10 を反映 ---- */
  function refreshRanking() {
    fetchRankingProducts().then(function (products) {
      products = products.slice(0, 10);
      if (!products.length) return;
      var scroller = document.querySelector(".sec-ranking .rank-scroller");
      if (!scroller) return;

      // 下敷き(CONTENT_F.RANKING_BAKED / CONTENT.RANKING)からhandle→review_count
      var rcMap = {};
      var pool = [].concat(
        (C.RANKING_BAKED || []),
        (typeof CONTENT !== "undefined" && CONTENT.RANKING) ? CONTENT.RANKING : []
      );
      pool.forEach(function (r) {
        var h = r.handle ||
          (r.url ? String(r.url).split("/products/")[1] : null);
        if (h && r.review_count != null) rcMap[h] = Number(r.review_count) || 0;
      });

      var frag = document.createDocumentFragment();
      var cards = [];   // {body, pid} — 描画後にJudge.me実件数で更新する
      products.forEach(function (p, i) {
        var img = (p.images && p.images[0] && p.images[0].src) || "";
        var price = (p.variants && p.variants[0] && p.variants[0].price) || "";
        var title = cleanTitle(p.title);
        var a = elem("a", "rank-card");
        a.href = SHOP + "/products/" + p.handle;
        a.setAttribute("aria-label", title);

        var media = elem("div", "rank-media");
        var badge = elem("span", "rank-badge");
        badge.textContent = String(i + 1);
        media.appendChild(badge);
        var im = elem("img", "rank-img");
        im.loading = "lazy";
        setImg(im, img, 220);
        im.alt = title;
        media.appendChild(im);
        a.appendChild(media);

        var body = elem("div", "rank-body");
        var tt = elem("p", "rank-title");
        tt.textContent = title;
        body.appendChild(tt);
        // 初期件数=下敷き（焼き込み値）。直後にJudge.me実件数で上書きする。
        var rc = rcMap[p.handle] || 0;
        if (rc > 0) body.appendChild(makeRate(rc));
        var pr = elem("p", "price");
        pr.textContent = yen(price);
        body.appendChild(pr);
        a.appendChild(body);
        frag.appendChild(a);
        cards.push({ body: body, pid: p.id });
      });
      scroller.innerHTML = "";
      scroller.appendChild(frag);

      // 描画後にJudge.meから実件数を取得して各カードを最新化（レビュー増減に追従）
      cards.forEach(function (c) {
        fetchReviewCount(c.pid).then(function (n) {
          if (n == null) return;              // 取得失敗=据置（創作禁止）
          updateRate(c.body, n);
        });
      });
    }).catch(function () { /* スナップショット維持 */ });
  }

  /* ★5＋(件数) の .rate ノードを生成 */
  function makeRate(n) {
    var rate = elem("div", "rate");
    rate.innerHTML = starsHTML(5) +
      '<span class="rate-count">(' + n + ')</span>';
    return rate;
  }

  /* rank-body の件数表示をJudge.me実件数へ同期。
     n>0で.rate無し→挿入（rank-titleの直後）／n>0で有り→数字更新／n=0→.rate除去 */
  function updateRate(body, n) {
    var rate = body.querySelector(".rate");
    if (n > 0) {
      if (!rate) {
        rate = makeRate(n);
        var title = body.querySelector(".rank-title");
        if (title && title.nextSibling) body.insertBefore(rate, title.nextSibling);
        else body.appendChild(rate);
      } else {
        var count = rate.querySelector(".rate-count");
        if (count) count.textContent = "(" + n + ")";
      }
    } else if (rate) {
      rate.parentNode.removeChild(rate);   // 0件になった商品は★行を消す
    }
  }

  /* ---- みんなのレビュー：Cloudflare Worker経由でPCA全商品の最新レビューを反映 ----
     2026-09-24: 「新着15∪ランキング10∪REVIEW_PRODUCT_IDS」で候補商品を先に絞ってから
     商品ごとにJudge.meを最大25回fetchしていた方式は廃止。Judge.meのPrivate API Token
     はテーマ側（このファイル・Liquid・ブラウザから見える場所）には一切置かず、
     トークンを保持する中継サーバー（Cloudflare Worker）へ1回fetchするだけにする。
     Workerは既にPCA全商品・published・★3〜5・新しい順・上位5件・商品画像URLまで
     整形済みのJSON（{reviews:[{rating, body, product_url, image, ...}]}）を返す。
     取得失敗時／空応答時は何もしない＝f-app.jsが初回描画した静的REVIEWSのカードを
     そのままフォールバックとして残す（.review-gridを触らない）。 */
  var REVIEWS_WORKER_URL = "https://pca-reviews-worker.pca-operations.workers.dev/latest";

  function refreshReviews() {
    getJSON(REVIEWS_WORKER_URL).then(function (d) {
      var list = (d && d.reviews) || [];
      if (!list.length) return; // 空応答なら静的スナップショットを維持
      var grid = document.querySelector(".sec-reviews .review-grid");
      if (!grid) return;
      var frag = document.createDocumentFragment();
      // 2026-09-24: PCで3列×2段=6件に揃えるため5→6に変更（Workerは既に最新6件を返す）。
      list.slice(0, 6).forEach(function (r) {
        var title = cleanTitle(r.product_title || "");
        var a = elem("a", "review-card");
        a.href = r.product_url || (r.product_handle ? SHOP + "/products/" + r.product_handle : SHOP);
        a.setAttribute("aria-label", title + " の商品ページへ");
        // 商品補足（product名の可視表示）・「この商品を見る→」は表示しない（要素ごと非生成）。
        var body = elem("div", "review-body");
        var rate = elem("div", "rate");
        rate.innerHTML = starsHTML(r.rating);
        body.appendChild(rate);
        var q = elem("blockquote", "review-quote");
        q.textContent = "“" + String(r.body || "").trim() + "”";
        body.appendChild(q);
        a.appendChild(body);
        if (r.image) {
          var im = elem("img", "review-thumb");
          setImg(im, r.image, 110);
          im.loading = "lazy";
          im.alt = title;
          a.appendChild(im);
        }
        frag.appendChild(a);
      });
      grid.innerHTML = "";
      grid.appendChild(frag);
    }).catch(function () { /* Worker障害時は静的スナップショット（f-app.js初回描画）を維持 */ });
  }

  /* ---- よみもの：本店ブログAtomフィードから最新記事を随時反映 ---- */
  function refreshArticles() {
    // Shopifyブログのハンドル「ニュース」はURLエンコード済みで叩く
    var url = SHOP + "/blogs/%E3%83%8B%E3%83%A5%E3%83%BC%E3%82%B9.atom";
    fetch(url, { mode: "cors", credentials: "omit" }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    }).then(function (xml) {
      var doc = new DOMParser().parseFromString(xml, "application/xml");
      var entries = doc.getElementsByTagName("entry");
      if (!entries.length) return;
      var e = entries[0];
      var title = ((e.getElementsByTagName("title")[0] || {}).textContent || "").trim();
      var pub = ((e.getElementsByTagName("published")[0] || {}).textContent || "").trim();
      var linkEl = e.getElementsByTagName("link")[0];
      var link = linkEl ? (linkEl.getAttribute("href") || "") : "";
      var content = (e.getElementsByTagName("content")[0] || {}).textContent || "";
      var m = content.match(/<img[^>]+src=["']([^"']+)["']/i);
      var img = m ? m[1] : "";
      if (img && !/[?&]width=/.test(img)) {
        img += (img.indexOf("?") >= 0 ? "&" : "?") + "width=800";
      }
      if (!title || !link) return;
      var date = pub.slice(0, 10).replace(/-/g, ".");
      var grid = document.querySelector(".sec-articles .article-grid");
      if (!grid) return;
      var a = elem("a", "article-card");
      a.href = link;
      a.setAttribute("aria-label", title);
      var thumb = elem("div", "article-thumb");
      var im = elem("img");
      im.loading = "lazy";
      setImg(im, img, 640);
      im.alt = title;
      thumb.appendChild(im);
      a.appendChild(thumb);
      var body = elem("div", "article-body");
      var dd = elem("span", "article-date");
      dd.textContent = date;
      body.appendChild(dd);
      var tt = elem("p", "article-title");
      tt.textContent = title;
      body.appendChild(tt);
      // 「読む →」は2026-09-24にクライアント指示で削除（要素ごと非生成。f-app.js側と統一）。
      a.appendChild(body);
      grid.innerHTML = "";
      grid.appendChild(a);
    }).catch(function () { /* スナップショット維持 */ });
  }

  // 初回描画の直後に非同期で最新化
  refreshNewArrivals();
  refreshRanking();
  refreshReviews();
  refreshArticles();
})();
